<template>
    <div class="advertisement-card" :data-ad-id="ad.id">
        <div class="advertisement-card__content">
            <h3 class="advertisement-card__headline">{{ ad.headline }}</h3>
            <a 
                :href="ad.url || '#'"
                class="advertisement-card__button"
                :target="ad.open_in_new_tab ? '_blank' : '_self'"
                :rel="ad.open_in_new_tab ? 'noopener noreferrer' : null"
            >
                {{ ad.button_text || 'CONTACT OUR TEAM' }}
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AdvertisementCard',
    props: {
        ad: {
            type: Object,
            required: true,
            default: () => ({
                id: null,
                headline: null,
                button_text: null,
                url: null,
                open_in_new_tab: false,
            }),
        }
    },
};
</script>

<style scoped>
.advertisement-card {
    position: relative;
    background-color: #45adbf;
    width: 245px;
    height: 274px;
    display: inline-block;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.advertisement-card__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 20px;
    text-align: center;
}

.advertisement-card__headline {
    font-family: 'Oswald', sans-serif;
    font-weight: 500;
    font-size: 27px;
    line-height: 33px;
    color: white;
    margin: 0 0 40px 0;
    white-space: pre-line;
}

.advertisement-card__button {
    background-color: black;
    border: none;
    color: white;
    font-family: 'Oswald', sans-serif;
    font-weight: 600;
    font-size: 18px;
    text-transform: uppercase;
    text-decoration: none;
    padding: 12px 24px;
    min-width: 218px;
    height: 41px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease, transform 0.2s ease;
}

.advertisement-card__button:hover {
    background-color: #333;
    transform: translateY(-1px);
}

.advertisement-card__button:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.5);
}

.advertisement-card__button:active {
    transform: translateY(0);
}
</style>